import { render } from "./BrandsBoxMarketplaces.vue?vue&type=template&id=79e430c0"
import script from "./BrandsBoxMarketplaces.vue?vue&type=script&lang=ts"
export * from "./BrandsBoxMarketplaces.vue?vue&type=script&lang=ts"
script.render = render

export default script